<template>
  <login-component :busy="busy" @login="loginAction" />
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import JbOAuth from '@/helpers/oauth'
import { GtmPushDataLayer } from '@/helpers/google'
import { insuranceInfos } from '@/helpers/insurances'
import { createUrlQueryParams } from '@/helpers/url'
import { validateEmailDomain } from '@/helpers/email'
import LoginComponent from '@/components/login/LoginComp.vue'
export default {
  name: 'LoginPage',
  components: {
    LoginComponent,
  },
  data() {
    return {
      busy: true,
    }
  },
  computed: {
    ...mapGetters({
      gtUser: 'user/user/gtUser',
    }),
  },
  async beforeMount() {
    if (JbOAuth.isAccessTokenValid()) {
      await this.actTrackAdCampaign('login')
      await this.loginAction()
      return
    }

    this.busy = false
  },
  methods: {
    ...mapActions({
      actGetUser: 'user/user/actGetUser',
      getPersona: 'user/persona/getPersona',
      actGetUserAttributes: 'user/user-attributes/actGetUserAttributes',
      actEmitGa4LoginEvent: 'services/ga/actEmitGa4LoginEvent',
      actTrackAdCampaign: 'user/user/actTrackAdCampaign',
      actOAuthSilentLogout: 'oauth/actOAuthSilentLogout',
      registerInsuranceTypes: 'services/tracker/registerInsuranceTypes',
    }),
    async loginAction() {
      this.busy = true
      const currentProduct = sessionStorage.getItem('product') || ''

      // GTM EVENT
      GtmPushDataLayer({
        user_id: this.gtUser?.id ?? '',
      })

      if (Object.keys(insuranceInfos)?.includes(currentProduct)) {
        await this.registerInsuranceTypes({
          ...this.gtUser,
          product: currentProduct,
          aff_id: sessionStorage.getItem('aff_id') ?? null,
          source: 'login',
          utm_campaign: sessionStorage.getItem('utm_campaign'),
        })

        this.actOAuthSilentLogout()

        window.location.href = `${
          insuranceInfos[currentProduct]
        }${createUrlQueryParams({
          email: this.gtUser.email,
          cpf: this.gtUser.cpf.replace(/\D/g, ''),
          user_id: this.gtUser?.id ?? '',
          source: 'login',
          utm_campaign: sessionStorage.getItem('utm_campaign'),
        })}`
      } else {
        this.redirectUserToLoggedArea()
      }
    },
    redirectUserToLoggedArea() {
      const productQuery = this.$route?.query?.product

      const redirectUserTo = (path, query) => {
        history.replaceState(
          {
            ...history.state,
            back: '/home',
            current: path,
          },
          'home',
          location.origin + '/home',
        )
        this.$router.push({
          path,
          ...(query ? { query } : {}),
        })
      }

      if (productQuery) {
        if (productQuery === 'debt_renegotiation') {
          redirectUserTo('/negociacao-dividas', { product: productQuery })
        } else if (productQuery === 'credit_card') {
          redirectUserTo('/cartao-credito/ofertas', { product: productQuery })
        } else if (productQuery === 'fgts') {
          redirectUserTo('/forms/emprestimo/fgts/simular')
        } else {
          redirectUserTo('/simular', { product: productQuery })
        }
      } else if (this.$route.query?.step === 'docs') {
        const { offer_id, partner, loan_type } = this.$route?.query
        redirectUserTo(`/contratacao/${loan_type}/${partner}/${offer_id}`, null)
      } else if (this.$route.query?.from === 'unlogged') {
        redirectUserTo('/ofertas', null)
      } else if (this.$route.query?.nextPage) {
        redirectUserTo(this.$route.query?.nextPage, null)
      } else if (
        !validateEmailDomain(this.gtUser?.email).valid ||
        !this.gtUser.name
      ) {
        this.$router.push({
          path: '/forms/perfil/dados-cadastrais',
        })
      } else {
        redirectUserTo('/home', null)
      }
    },
  },
}
</script>
